<phx-select
  phxDropdownClassName="phx-button-select-dropdown-custom-style"
  [phxDropdownWidth]="phxDropdownWidth"
  [phxPlaceholder]="phxPlaceholder"
  [phxTriggerTemplate]="phxSelectTrigger"
  [phxAllowClear]="false"
  [disabled]="disabled"
  [ngModel]="selectedOption?.value"
  (phxSelectionChange)="updateSelectedOption($event)"
>
  <phx-select-option
    *ngFor="let option of phxOptions"
    [isDivider]="option.isDivider"
    [label]="option.label"
    [value]="option.value"
    [data]="option.data"
    [disabled]="option.disabled"
    [phxOptionTemplate]="option.isDivider ? null : phxSelectOption"
  ></phx-select-option>
</phx-select>

<ng-template #phxSelectTrigger>
  <button
    phx-button
    [disabled]="disabled"
    [phxSuffixIcon]="ChevronDownIcon"
    [phxPrefixIcon]="selectedOption?.data.icon"
    [phxButtonType]="selectedOption?.data.buttonType || 'default'"
    [phxButtonRole]="selectedOption?.data.buttonRole || 'primary'"
    [phxSize]="phxSize"
    [phxFullWidth]="true"
  >
    {{ selectedOption?.label }}
  </button>
</ng-template>

<ng-template #phxSelectOption let-opt>
  <div
    class="phx-button-select-option"
    phx-tooltip
    phxPlacement="left"
    [phxContent]="opt.data.tooltipContent"
    [phxTrigger]="opt.data.tooltipTrigger || 'hover'"
  >
    <i *ngIf="opt.data.icon" class="phx-button-select-prefix" phx-icon [phxIcon]="opt.data.icon" [color]="getIconColor(opt.data.iconColor, opt.disabled)"></i>
    <span class="text">{{ opt.label }}</span>
  </div>
</ng-template>
